import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useIntl } from "react-intl";
import FormInput from "../../inputs/FormInput";

export default function ClientInfos() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const { sav_form } = useIntl().messages;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
  };

  const handleEmailInputBlur = () => {
    if (email && !emailRegex.test(email)) {
      setError(sav_form.email.error);
    } else {
      setError("");
    }
  };

  return (
    <VStack spacing={5} mt={5}>
      <Grid
        templateColumns={{
          sm: "repeat(2, 1fr)",
        }}
        gap={5}
        width="100%"
      >
        <FormInput
          required
          type="text"
          name="firstName"
          placeholder={sav_form.firstName.placeholder}
        >
          {sav_form.firstName.label}
        </FormInput>
        <FormInput
          required
          type="text"
          name="lastName"
          placeholder={sav_form.lastName.placeholder}
        >
          {sav_form.lastName.label}
        </FormInput>
        <FormInput
          required
          type="text"
          name="postalAddress"
          placeholder={sav_form.address.placeholder}
        >
          {sav_form.address.label}
        </FormInput>
        <FormInput
          type="text"
          name="additionalAddress"
          placeholder={sav_form.additionalAddress.placeholder}
        >
          {sav_form.additionalAddress.label}
        </FormInput>
        <FormInput
          required
          type="text"
          name="postalCode"
          placeholder={sav_form.postal_code.placeholder}
        >
          {sav_form.postal_code.label}
        </FormInput>
        <FormInput
          required
          type="text"
          name="city"
          placeholder={sav_form.city.placeholder}
        >
          {sav_form.city.label}
        </FormInput>

        <GridItem colSpan={2}>
          <FormControl isRequired isInvalid={!!error}>
            <FormLabel htmlFor="email">{sav_form.email.label}</FormLabel>
            <Input
              type="email"
              id="email"
              name="email"
              placeholder={sav_form.email.placeholder}
              value={email}
              onChange={handleEmailChange}
              onBlur={handleEmailInputBlur}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>
        </GridItem>
        <GridItem colSpan={2}>
          <FormInput
            required
            type="text"
            name="phone"
            placeholder={sav_form.phone.placeholder}
          >
            {sav_form.phone.label}
          </FormInput>
        </GridItem>
      </Grid>
    </VStack>
  );
}
